// comment-reply-form v1: 评论回复输入组件

import React, { useState, useEffect } from 'react';

import { getCurrentUserAvatar } from '../../../utils/currentUser';

/**
 * 评论回复输入组件
 * @param {string} parentId - 父评论ID
 * @param {string} parentAuthorName - 父评论作者姓名
 * @param {string} draft - 草稿内容
 * @param {Function} onChange - 内容变化事件
 * @param {Function} onSubmit - 提交事件
 * @param {Function} onCancel - 取消事件
 * @param {string} className - 额外的CSS类名
 */
const CommentReplyForm = ({
  parentId,
  parentAuthorName,
  draft,
  onChange,
  onSubmit,
  onCancel,
  className = '',
}) => {
  const [avatarUrl, setAvatarUrl] = useState(null);
  const [isLoadingAvatar, setIsLoadingAvatar] = useState(true);

  useEffect(() => {
    const loadAvatar = async () => {
      try {
        setIsLoadingAvatar(true);
        const avatar = await getCurrentUserAvatar();
        setAvatarUrl(avatar);
      } catch (error) {
        console.warn('[CommentReplyForm] Failed to load avatar:', error);
        setAvatarUrl(null);
      } finally {
        setIsLoadingAvatar(false);
      }
    };

    loadAvatar();
  }, []);

  const handleKeyDown = e => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      onSubmit(parentId);
    }
  };

  return (
    <div className={`mt-2 pl-10 ${className}`}>
      <div className='flex items-start space-x-3'>
        <img
          src={avatarUrl || '/default-avatar.png'}
          alt='Your avatar'
          className='w-8 h-8 rounded-full flex-shrink-0'
        />
        <div className='flex-1'>
          <textarea
            value={draft || ''}
            onChange={e => onChange(parentId, e.target.value)}
            placeholder={`Reply to ${parentAuthorName}…`}
            rows={2}
            className='w-full p-2 border border-gray-300 rounded-md text-sm resize-none focus:outline-none focus:ring-2 focus:ring-tag-blue focus:border-transparent bg-gray-800 text-white placeholder-gray-400'
            onKeyDown={handleKeyDown}
          />
          <div className='mt-2 flex gap-2'>
            <button
              className='px-6 py-1 rounded bg-transparent border border-blue-500 text-blue-500 text-sm hover:bg-blue-500 hover:text-white transition-colors duration-200 font-bold'
              onClick={() => onSubmit(parentId)}
            >
              POST
            </button>
            <button
              className='px-3 py-1 rounded border border-gray-300 text-white text-sm hover:bg-gray-800 transition-colors duration-200'
              onClick={onCancel}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommentReplyForm;
